module.exports = __webpack_public_path__ + "img/texto-izquierda.0e3cd798.jpg";